import React from 'react';

const MedicalRecords: React.FC = () => {
  return (
    <>
      <div className="content-header">
        <div className="container-fluid">
          <div className="row mb-2">
            <div className="col-sm-6">
              <h1 className="m-0">Prontuários</h1>
            </div>
          </div>
        </div>
      </div>

      <section className="content">
        <div className="container-fluid">
          <div className="row">
            <div className="col-12">
              <div className="card">
                <div className="card-header">
                  <h3 className="card-title">Lista de Prontuários</h3>
                  <div className="card-tools">
                    <button type="button" className="btn btn-primary">
                      <i className="fas fa-plus"></i> Novo Prontuário
                    </button>
                  </div>
                </div>
                <div className="card-body">
                  <p>Lista de prontuários será implementada aqui.</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default MedicalRecords;